import React, { useEffect, useState, useRef } from 'react';
import { HashRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../INVENTORY/Assets/styles/addmenu.css';
import '../INVENTORY/Assets/styles/style.css';
import '../SalesTrading/Assets/Style/style.css';
import { getRole } from '../Redux/selecters/index';
import PlainLayout from '../POS/component/pages/SideBar/plainLayout';
// import Login from '../POS/component/pages/user/Login';
import Signup from '../POS/component/pages/user/signup';
import DashBoard from '../INVENTORY/Pages/dashBoard/dashboard';
import SaleOrder from '../SalesTrading/Pages/salesOrder/salesOrder';
import CreateSaleOrder from '../SalesTrading/Pages/salesOrder/createSaleOrder';
import { CurrencyProvider } from '../INVENTORY/Layouts/currencyContext';
import DRNListing from '../SalesTrading/Pages/DRN/DRNList';
import CreateDRN from '../SalesTrading/Pages/DRN/createDRN';
import CustomerInvoiceListing from '../SalesTrading/Pages/customerInvoice/customerInvoice';
import CreateCustomerInv from '../SalesTrading/Pages/customerInvoice/createCustomerInv';
import QuotationListing from '../SalesTrading/Pages/Quotation/quotationList';
import CreateQuotation from '../SalesTrading/Pages/Quotation/createQuotation';
import MainSalesLayout from '../SalesTrading/Layouts/mainLayout';
import QuotationView from '../SalesTrading/Pages/Quotation/quotationView';
import SalesInvoicePrint from '../SalesTrading/Pages/customerInvoice/print';
import SalesReturn from '../SalesTrading/Pages/salesReturn/salesReturn';
import SaleReturnCreate from '../SalesTrading/Pages/salesReturn/saleReturnCreate';
import QuotationPrint from '../SalesTrading/Pages/Quotation/print';
import SaleOrderPrint from '../SalesTrading/Pages/salesOrder/print';
import DNPrint from '../SalesTrading/Pages/DRN/print';
import SaleOrderView from '../SalesTrading/Pages/salesOrder/view';
import DnView from '../SalesTrading/Pages/DRN/view';
import CustomerInvView from '../SalesTrading/Pages/customerInvoice/invoiceview';
import Posting from '../SalesTrading/Pages/posting/posting';
import InventoryLogin from '../INVENTORY/Components/login/login';
import QuotationRevision from '../SalesTrading/Pages/Quotation/revision';
import SaleReturnPrint from '../SalesTrading/Pages/salesReturn/returnPrint';
import MainPMLayout from '../PropertyManagement/Layouts/mainLayout';
import PropertyDashBoard from '../PropertyManagement/Pages/dashboard/dashBoard';
import ProtectedRoute from '../PropertyManagement/Components/routesSetting/protectedRoutes';
import NoAccess from './noAccess';
import ListingDashboard from '../PropertyManagement/Pages/dashboard/dashboardListing';
import Dashboard from '../PropertyManagement/Pages/dashboard/dashboardListing';
import CustomerListing from '../PropertyManagement/Pages/customerMaster/listing';
import CustomerMaster from '../PropertyManagement/Pages/customerMaster/customerMaster';
import UpdateCustomerMaster from '../PropertyManagement/Pages/customerMaster/editCustomer';
import OccupancyReport from '../PropertyManagement/Pages/reports/occupancyReport';
import LeaseStatement from '../PropertyManagement/Pages/reports/leaseStatement';
import ReceiptLog from '../PropertyManagement/Pages/reports/receiptLog';
import ReceiptLogNarration from '../PropertyManagement/Pages/reports/receiptLogNarratoin';
import RevenueRental from '../PropertyManagement/Pages/reports/revenueRental';
import LeaseMoveInOut from '../PropertyManagement/Pages/reports/moveInOut';
import AgentCommission from '../PropertyManagement/Pages/agentCommission/agentCommission';
import LeaseBalancePayment from '../PropertyManagement/Pages/reports/balancePayment';
import LeaseExpiry from '../PropertyManagement/Pages/reports/leaseExpiry';
import RefundAnalysis from '../PropertyManagement/Pages/reports/refundAnalysis';
import AvailableUnitsLoss from '../PropertyManagement/Pages/reports/availableUnitLoss';
import LeaseInvoicePrint from '../PropertyManagement/Pages/reports/LeaseInvoicePrint';
import AgentMasterListing from '../PropertyManagement/Pages/agentMaster/listing';
import AgentMasterCreate from '../PropertyManagement/Pages/masters/createAgent';
import BrokerMasterListing from '../PropertyManagement/Pages/brokerMaster/brokerMaster';
import PropertyListing from '../PropertyManagement/Pages/propertyMaster/listing';
import PropertyMasterCreate from '../PropertyManagement/Pages/propertyMaster/propertyCreate';
import UnitListing from '../PropertyManagement/Pages/unitMaster/listing';
import CreateUnitMaster from '../PropertyManagement/Pages/unitMaster/createUnit';
import UpdateUnitMaster from '../PropertyManagement/Pages/unitMaster/updateUnitMaster';
import PropertyMasterUpdate from '../PropertyManagement/Pages/propertyMaster/updateProperty';
import PropertyMasterView from '../PropertyManagement/Pages/propertyMaster/view';
import ViewUnitMaster from '../PropertyManagement/Pages/unitMaster/view';
// import UnitReleaseListing from '../PropertyManagement/Pages/unitRelease/listing';
import UnitBlockListing from '../PropertyManagement/Pages/unitBlock/listing';
import UnitReleaseListing from '../PropertyManagement/Pages/unitBlock/releaseListing';
import UnitReleaseRAListing from '../PropertyManagement/Pages/unitReleaseRA/listing';
import UnitReleaseRAPage from '../PropertyManagement/Pages/unitReleaseRA/page';

const AppRoutes = () => {
  const role = useSelector(getRole);
  const [userRole, setUserRole] = useState(role);
  const navigate = useNavigate();
  const permissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
  // const [permissions, setPermissions] = useState([]);

  // useEffect(() => {
  //   // const permissions = storedPermissions?.filter(acc => acc.formName === "Lease Receipt");
  //   setPermissions(storedPermissions);
  // }, [])
  return (
    <CurrencyProvider>
      <Routes>
        {!userRole && (
          <>
            {/* Customer routes */}
            <Route
              path="/login"
              element={
                <PlainLayout>
                  <InventoryLogin />
                </PlainLayout>
              }
            />
            <Route
              path="/signup"
              element={
                <PlainLayout>
                  <Signup />
                </PlainLayout>
              }
            />
          </>
        )}
        {/* <Route path="/" element={<MainSalesLayout><DashBoard /></MainSalesLayout>} /> */}
        <>
          {/* Sales Routes */}
          {/* Property Management */}
          <Route
            path="/"
            element={
              <MainPMLayout>
                <Dashboard />
              </MainPMLayout>
            }
          />
          <Route
            path="/listing"
            element={
              <MainPMLayout>
                <PropertyDashBoard />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Customer/Listing"
            element={
              <MainPMLayout>
                <CustomerListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Customer/Create"
            element={
              <MainPMLayout>
                <CustomerMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Customer/Update"
            element={
              <MainPMLayout>
                <UpdateCustomerMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Agent/listing"
            element={
              <MainPMLayout>
                <AgentMasterListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Agent/Create"
            element={
              <MainPMLayout>
                <AgentMasterCreate />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Broker/Listing"
            element={
              <MainPMLayout>
                <BrokerMasterListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Property/Listing"
            element={
              <MainPMLayout>
                <PropertyListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Property/Create"
            element={
              <MainPMLayout>
                <PropertyMasterCreate />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Property/Update"
            element={
              <MainPMLayout>
                <PropertyMasterUpdate />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Property/view"
            element={
              <MainPMLayout>
                <PropertyMasterView />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/Listing"
            element={
              <MainPMLayout>
                <UnitListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/Create"
            element={
              <MainPMLayout>
                <CreateUnitMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/Update"
            element={
              <MainPMLayout>
                <UpdateUnitMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/view"
            element={
              <MainPMLayout>
                <ViewUnitMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/listing"
            element={
              <MainPMLayout>
                <UnitListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/Release/Listing"
            element={
              <MainPMLayout>
                <UnitReleaseListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/Unit/Release/View"
            element={
              <MainPMLayout>
                <ViewUnitMaster />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/UnitBlock/Listing"
            element={
              <MainPMLayout>
                <UnitBlockListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/UnitRelease/Listing"
            element={
              <MainPMLayout>
                <UnitReleaseListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/UnitReleaseRA/Listing"
            element={
              <MainPMLayout>
                <UnitReleaseRAListing />
              </MainPMLayout>
            }
          />
          <Route
            path="/Customer/Property/Master/UnitReleaseRA/Create"
            element={
              <MainPMLayout>
                <UnitReleaseRAPage />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Occupancy"
            element={
              <MainPMLayout>
                <OccupancyReport />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Lease_Statement"
            element={
              <MainPMLayout>
                <LeaseStatement />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Receipt-log"
            element={
              <MainPMLayout>
                <ReceiptLog />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Receipt-log_Narration"
            element={
              <MainPMLayout>
                <ReceiptLogNarration />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Revenue_Rental"
            element={
              <MainPMLayout>
                <RevenueRental />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/Move_IN_OUT"
            element={
              <MainPMLayout>
                <LeaseMoveInOut />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/LeaseExpiry"
            element={
              <MainPMLayout>
                <LeaseExpiry />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/RefundAnalysis"
            element={
              <MainPMLayout>
                <RefundAnalysis />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Report/RevenueLoss"
            element={
              <MainPMLayout>
                <AvailableUnitsLoss />
              </MainPMLayout>
            }
          />
          <Route
            path="/Lease/Management/Lease/Agent/Commission"
            element={
              <MainPMLayout>
                <AgentCommission />
              </MainPMLayout>
            }
          />
        </>
      </Routes>
    </CurrencyProvider>
  );
};

export default AppRoutes;
